/*  @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';
import { updateEditCountry } from 'permissions/account';

const actionsListData: any = [
  {
    label: 'general:actions.start_audit_from_locations',
    icon: '#icon-approve',
    class: '',
    action: 'startAuditByLocations',
    permissions: updateEditCountry,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const vData = data && (data.locationDetails ? data.locationDetails : data.details);
      return <ActionButton data={vData} action={action} onActionDrawer={callback} />;
    },
  },
];

export default actionsListData;
